import { LoginCredentials, AuthResponse, LoginResponse } from '@/types/auth';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  const response = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Invalid credentials');
  }

  const data = await response.json();
  console.log('Login response:', data); // Add this line
  // Store auth data immediately after successful login
  setStoredAuth(data);
  return data;
}

export function getStoredAuth(): AuthResponse | null {
  const stored = localStorage.getItem('auth');
  return stored ? JSON.parse(stored) : null;
}

export function setStoredAuth(auth: AuthResponse | null): void {
  if (auth) {
    localStorage.setItem('auth', JSON.stringify(auth));
  } else {
    localStorage.removeItem('auth');
  }
}